var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view'),_c('global-notification'),_c('update-pwa'),_c('network-detector')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }